import ADAUSD from './icons/currency/ADAUSD.svg';
import AUDCAD from './icons/currency/AUDCAD.svg';
import AUDCHF from './icons/currency/AUDCHF.svg';
import AUDJPY from './icons/currency/AUDJPY.svg';
import AUDNZD from './icons/currency/AUDNZD.svg';
import AUDUSD from './icons/currency/AUDUSD.svg';
import AUS200 from './icons/currency/AUS200.svg';
import BTCUSD from './icons/currency/BTCUSD.svg';
import CADCHF from './icons/currency/CADCHF.svg';
import CADJPY from './icons/currency/CADJPY.svg';
import CHNIND from './icons/currency/CHNIND.svg';
import DOTUSD from './icons/currency/DOTUSD.svg';
import ETHUSD from './icons/currency/ETHUSD.svg';
import EU50 from './icons/currency/EU50.svg';
import EURAUD from './icons/currency/EURAUD.svg';
import EURCAD from './icons/currency/EURCAD.svg';
import EURCHF from './icons/currency/EURCHF.svg';
import EURGBP from './icons/currency/EURGBP.svg';
import EURJPY from './icons/currency/EURJPY.svg';
import EURNZD from './icons/currency/EURNZD.svg';
import EURUSD from './icons/currency/EURUSD.svg';
import FRA40 from './icons/currency/FRA40.svg';
import GBPAUD from './icons/currency/GBPAUD.svg';
import GBPCAD from './icons/currency/GBPCAD.svg';
import GBPCHF from './icons/currency/GBPCHF.svg';
import GBPJPY from './icons/currency/GBPJPY.svg';
import GBPNZD from './icons/currency/GBPNZD.svg';
import GBPUSD from './icons/currency/GBPUSD.svg';
import GER30 from './icons/currency/GER30.svg';
import HKIND from './icons/currency/HKIND.svg';
import ITA40 from './icons/currency/ITA40.svg';
import JAP225 from './icons/currency/JAP225.svg';
import LTCUSD from './icons/currency/LTCUSD.svg';
import NZDCAD from './icons/currency/NZDCAD.svg';
import NZDCHF from './icons/currency/NZDCHF.svg';
import NZDJPY from './icons/currency/NZDJPY.svg';
import NZDUSD from './icons/currency/NZDUSD.svg';
import SPA35 from './icons/currency/SPA35.svg';
import UK100 from './icons/currency/UK100.svg';
import US30 from './icons/currency/US30.svg';
import US100 from './icons/currency/US100.svg';
import US500 from './icons/currency/US500.svg';
import USDCAD from './icons/currency/USDCAD.svg';
import USDCHF from './icons/currency/USDCHF.svg';
import USDHKD from './icons/currency/USDHKD.svg';
import USDJPY from './icons/currency/USDJPY.svg';
import XAGUSD from './icons/currency/XAGUSD.svg';
import XAUUSD from './icons/currency/XAUUSD.svg';
import XLMUSD from './icons/currency/XLMUSD.svg';
import XPDUSD from './icons/currency/XPDUSD.svg';
import XPTUSD from './icons/currency/XPTUSD.svg';
import XRPUSD from './icons/currency/XRPUSD.svg';
import ALUMINIUM from './icons/currency/AL.svg';
import ALGUSD from './icons/currency/ALGUSD.svg';
import ATOUSD from './icons/currency/ATOUSD.svg';
import AVEUSD from './icons/currency/AVEUSD.svg';
import AVXUSD from './icons/currency/AVXUSD.svg';
import AXSUSD from './icons/currency/AXSUSD.svg';
import BCHBTC from './icons/currency/BCHBTC.svg';
import BCHUSD from './icons/currency/BCHUSD.svg';
import BNBUSD from './icons/currency/BNBUSD.svg';
import BRAIND from './icons/currency/BRAIND.svg';
import BRENT from './icons/currency/BRENT.svg';
import BSVUSD from './icons/currency/BSVUSD.svg';
import BTCEUR from './icons/currency/BTCEUR.svg';
import BTTUSD from './icons/currency/BTTUSD.svg';
import BUND from './icons/currency/BUND.svg';
import CHFJPY from './icons/currency/CHFJPY.svg';
import CHZUSD from './icons/currency/CHZUSD.svg';
import CKEUSD from './icons/currency/CKEUSD.svg';
import COCOA from './icons/currency/COCOA.svg';
import COFFEE from './icons/currency/COFFEE.svg';
import CORN from './icons/currency/CORN.svg';
import COTTON from './icons/currency/COTTON.svg';
import CROUSD from './icons/currency/CROUSD.svg';
import COPPER from './icons/currency/CU.svg';
import DOGUSD from './icons/currency/DOGUSD.svg';
import DSHUSD from './icons/currency/DSHUSD.svg';
import ENJUSD from './icons/currency/ENJUSD.svg';
import EOSUSD from './icons/currency/EOSUSD.svg';
import ETHBTC from './icons/currency/ETHBTC.svg';
import ETHEUR from './icons/currency/ETHEUR.svg';
import EURNOK from './icons/currency/EURNOK.svg';
import EURSEK from './icons/currency/EURSEK.svg';
import EURPLN from './icons/currency/EURPLN.svg';
import EURTRY from './icons/currency/EURTRY.svg';
import FTMUSD from './icons/currency/FTMUSD.svg';
import FTTUSD from './icons/currency/FTTUSD.svg';
import HTHUSD from './icons/currency/HTHUSD.svg';
import IND50 from './icons/currency/IND50.svg';
import KOSP200 from './icons/currency/KOSP200.svg';
import LNKUSD from './icons/currency/LNKUSD.svg';
import LTCBTC from './icons/currency/LTCBTC.svg';
import MEXIND from './icons/currency/MEXIND.svg';
import MNAUSD from './icons/currency/MNAUSD.svg';
import MTCUSD from './icons/currency/MTCUSD.svg';
import NGAS from './icons/currency/NGAS.svg';
import ONEUSD from './icons/currency/ONEUSD.svg';
import RSA40 from './icons/currency/RSA40.svg';
import RUS50 from './icons/currency/RUS50.svg';
import SGDJPY from './icons/currency/SGDJPY.svg';
// import SHDUSD from './icons/currency/SHDUSD.svg';
import SNDUSD from './icons/currency/SNDUSD.svg';
import SNXUSD from './icons/currency/SNXUSD.svg';
import SOLUSD from './icons/currency/SOLUSD.svg';
import SOYBEAN from './icons/currency/SOYBEAN.svg';
import SUGAR from './icons/currency/SUGAR.svg';
import SUI20 from './icons/currency/SUI20.svg';
import THTUSD from './icons/currency/THTUSD.svg';
import TRXUSD from './icons/currency/TRXUSD.svg';
import TNOTE from './icons/currency/TNOTE.svg';
// import URXUSD from './icons/currency/URXUSD.svg';
import UNIUSD from './icons/currency/UNIUSD.svg';
import US2000 from './icons/currency/US2000.svg';
import USDIDX from './icons/currency/USDIDX.svg';
import USDMXN from './icons/currency/USDMXN.svg';
import USDNOK from './icons/currency/USDNOK.svg';
import USDPLN from './icons/currency/USDPLN.svg';
import USDRUB from './icons/currency/USDRUB.svg';
import USDSEK from './icons/currency/USDSEK.svg';
import USDSGD from './icons/currency/USDSGD.svg';
import USDTRY from './icons/currency/USDTRY.svg';
import USDZAR from './icons/currency/USDZAR.svg';
import VETUSD from './icons/currency/VETUSD.svg';
import VIX from './icons/currency/VIX.svg';
import W20 from './icons/currency/W20.svg';
import WAVUSD from './icons/currency/WAVUSD.svg';
import WHEAT from './icons/currency/WHEAT.svg';
import WTI from './icons/currency/WTI.svg';
import XEMUSD from './icons/currency/XEMUSD.svg';
import XMRUSD from './icons/currency/XMRUSD.svg';
import XRPEUR from './icons/currency/XRPEUR.svg';
import XTZUSD from './icons/currency/XTZUSD.svg';
import YFIUSD from './icons/currency/YFIUSD.svg';
import ZINC from './icons/currency/ZN.svg';

export const DISONA_CURRENCY_ICONS = [
  { label: 'ADAUSD', src: ADAUSD },
  { label: 'AUDCAD', src: AUDCAD },
  { label: 'AUDCHF', src: AUDCHF },
  { label: 'AUDJPY', src: AUDJPY },
  { label: 'AUDNZD', src: AUDNZD },
  { label: 'AUDUSD', src: AUDUSD },
  { label: 'AUS200', src: AUS200 },
  { label: 'BTCUSD', src: BTCUSD },
  { label: 'CADCHF', src: CADCHF },
  { label: 'CADJPY', src: CADJPY },
  { label: 'CHNIND', src: CHNIND },
  { label: 'DOTUSD', src: DOTUSD },
  { label: 'ETHUSD', src: ETHUSD },
  { label: 'EU50', src: EU50 },
  { label: 'EURAUD', src: EURAUD },
  { label: 'EURCAD', src: EURCAD },
  { label: 'EURCHF', src: EURCHF },
  { label: 'EURGBP', src: EURGBP },
  { label: 'EURJPY', src: EURJPY },
  { label: 'EURNZD', src: EURNZD },
  { label: 'EURUSD', src: EURUSD },
  { label: 'FRA40', src: FRA40 },
  { label: 'EU50', src: EU50 },
  { label: 'GBPAUD', src: GBPAUD },
  { label: 'GBPCAD', src: GBPCAD },
  { label: 'GBPCHF', src: GBPCHF },
  { label: 'GBPJPY', src: GBPJPY },
  { label: 'GBPNZD', src: GBPNZD },
  { label: 'GBPUSD', src: GBPUSD },
  { label: 'GER30', src: GER30 },
  { label: 'HKIND', src: HKIND },
  { label: 'ITA40', src: ITA40 },
  { label: 'JAP225', src: JAP225 },
  { label: 'LTCUSD', src: LTCUSD },
  { label: 'NZDCAD', src: NZDCAD },
  { label: 'NZDCHF', src: NZDCHF },
  { label: 'NZDJPY', src: NZDJPY },
  { label: 'NZDUSD', src: NZDUSD },
  { label: 'SPA35', src: SPA35 },
  { label: 'UK100', src: UK100 },
  { label: 'US30', src: US30 },
  { label: 'US100', src: US100 },
  { label: 'US500', src: US500 },
  { label: 'USDCAD', src: USDCAD },
  { label: 'USDCHF', src: USDCHF },
  { label: 'USDHKD', src: USDHKD },
  { label: 'USDJPY', src: USDJPY },
  { label: 'XAGUSD', src: XAGUSD },
  { label: 'XAUUSD', src: XAUUSD },
  { label: 'XLMUSD', src: XLMUSD },
  { label: 'XPDUSD', src: XPDUSD },
  { label: 'XPTUSD', src: XPTUSD },
  { label: 'XRPUSD', src: XRPUSD },
  { label: 'ALUMINIUM', src: ALUMINIUM },
  { label: 'ALGUSD', src: ALGUSD },
  { label: 'ATOUSD', src: ATOUSD },
  { label: 'AVEUSD', src: AVEUSD },
  { label: 'AVXUSD', src: AVXUSD },
  { label: 'AXSUSD', src: AXSUSD },
  { label: 'BCHBTC', src: BCHBTC },
  { label: 'BCHUSD', src: BCHUSD },
  { label: 'BNBUSD', src: BNBUSD },
  { label: 'BRAIND', src: BRAIND },
  { label: 'BSVUSD', src: BSVUSD },
  { label: 'BTCEUR', src: BTCEUR },
  { label: 'BTTUSD', src: BTTUSD },
  { label: 'BUND', src: BUND },
  { label: 'BRENT', src: BRENT },
  { label: 'CHFJPY', src: CHFJPY },
  { label: 'CHZUSD', src: CHZUSD },
  { label: 'CKEUSD', src: CKEUSD },
  { label: 'COCOA', src: COCOA },
  { label: 'COFFEE', src: COFFEE },
  { label: 'CORN', src: CORN },
  { label: 'COTTON', src: COTTON },
  { label: 'CROUSD', src: CROUSD },
  { label: 'COPPER', src: COPPER },
  { label: 'DOGUSD', src: DOGUSD },
  { label: 'DSHUSD', src: DSHUSD },
  { label: 'ENJUSD', src: ENJUSD },
  { label: 'EOSUSD', src: EOSUSD },
  { label: 'ETHBTC', src: ETHBTC },
  { label: 'ETHEUR', src: ETHEUR },
  { label: 'EURNOK', src: EURNOK },
  { label: 'EURSEK', src: EURSEK },
  { label: 'EURPLN', src: EURPLN },
  { label: 'EURTRY', src: EURTRY },
  { label: 'FTMUSD', src: FTMUSD },
  { label: 'FTTUSD', src: FTTUSD },
  { label: 'HTHUSD', src: HTHUSD },
  { label: 'IND50', src: IND50 },
  { label: 'KOSP200', src: KOSP200 },
  { label: 'LNKUSD', src: LNKUSD },
  { label: 'LTCBTC', src: LTCBTC },
  { label: 'EURTRY', src: EURTRY },
  { label: 'FTMUSD', src: FTMUSD },
  { label: 'FTTUSD', src: FTTUSD },
  { label: 'MEXIND', src: MEXIND },
  { label: 'MNAUSD', src: MNAUSD },
  { label: 'MTCUSD', src: MTCUSD },
  { label: 'NGAS', src: NGAS },
  { label: 'ONEUSD', src: ONEUSD },
  { label: 'RSA40', src: RSA40 },
  { label: 'RUS50', src: RUS50 },
  { label: 'SGDJPY', src: SGDJPY },
  // { label: 'SHDUSD', src: SHDUSD },
  { label: 'SNDUSD', src: SNDUSD },
  { label: 'SNXUSD', src: SNXUSD },
  { label: 'SOLUSD', src: SOLUSD },
  { label: 'SOYBEAN', src: SOYBEAN },
  { label: 'SUGAR', src: SUGAR },
  { label: 'SUI20', src: SUI20 },
  { label: 'THTUSD', src: THTUSD },
  { label: 'TRXUSD', src: TRXUSD },
  { label: 'TNOTE', src: TNOTE },
  // { label: 'URXUSD', src: URXUSD },
  { label: 'UNIUSD', src: UNIUSD },
  { label: 'US2000', src: US2000 },
  { label: 'USDIDX', src: USDIDX },
  { label: 'USDMXN', src: USDMXN },
  { label: 'USDNOK', src: USDNOK },
  { label: 'USDPLN', src: USDPLN },
  { label: 'USDRUB', src: USDRUB },
  { label: 'USDSEK', src: USDSEK },
  { label: 'USDSGD', src: USDSGD },
  { label: 'USDTRY', src: USDTRY },
  { label: 'USDZAR', src: USDZAR },
  { label: 'VETUSD', src: VETUSD },
  { label: 'VIX', src: VIX },
  { label: 'W20', src: W20 },
  { label: 'WAVUSD', src: WAVUSD },
  { label: 'WHEAT', src: WHEAT },
  { label: 'WTI', src: WTI },
  { label: 'XEMUSD', src: XEMUSD },
  { label: 'XMRUSD', src: XMRUSD },
  { label: 'XRPEUR', src: XRPEUR },
  { label: 'XTZUSD', src: XTZUSD },
  { label: 'YFIUSD', src: YFIUSD },
  { label: 'ZINC', src: ZINC },
];
